import { createContext, useContext } from 'react';

import routerStore from 'stores/routerStore';
import authStore from 'stores/authStore';
import usersStore from 'stores/usersStore';
import rolesStore from 'stores/rolesStore';
import gamesStore from 'stores/gamesStore';
import postsStore from 'stores/postsStore';
import languagesStore from 'stores/languagesStore';
import botsStore from 'stores/botsStore';

export const storesContext = createContext({
  routerStore,
  authStore,
  usersStore,
  rolesStore,
  gamesStore,
  languagesStore,
  postsStore,
  botsStore,
});

export const useStores = () => useContext(storesContext);
